import { Card } from "antd";
import React from "react";

function TeamCard({ onPress, icon, title }) {
  return (
    <Card hoverable className="card_Comp" onClick={onPress}>
      <div className="internal_Con">
        {icon}
        <h5 className="titleText">{title}</h5>
      </div>
    </Card>
  );
}

export default TeamCard;
